export enum DistributionType {
	Unique = 1,
	SingleLink = 2,
	SingleLinkWithoutDistribution = 3,
	SingleLinkWithAccessCode = 4,
	GroupBasedLinks = 5,
	SSO = 6,
}
